import React, { useState, useEffect, useContext, useRef, Fragment } from "react";
import { OffLineAPI } from "../../../offline-auth/api";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/buttons/IconButton.css";
import "../../../ui-styles/list/ListAutoUnderLine.css";
import "../../../ui-styles/cropper/imagecrop.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import PreviewTemplate from "./previewTemplate";
import {LangCtx } from "../../../lib/context";
import Loader from "../../../lib/ui/loader/Loader";
import { getDoctorSignature, scan } from "../../../actions/appointment";
import { updateDoctorSignature, deletedocSignature } from "../../../actions/schedule";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../common/deleteModal";

import Demo from "../../common/imagecropper/easycropper";
// const DigitalSignature = (props) => {
//     return <p>sdadadsda</p>
// }

const DigitalSignature = () => {
    const [openPreview, setOpenPreview] = useState(false);
    const { l } = useContext(LangCtx);
    //const imgRef = useRef(null);
    //const [imgSrc, setImgSrc] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [deleteObj, setDeleteObj] = useState(null);
    const h_ref = useRef(null);
    const s_ref = useRef(null);
    const f_ref = useRef(null);

    const [trtgt,setTrtgt]=useState(null)

    const [fname,setFname]=useState("")


    const [openCrop, setOpenCrop] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(undefined);

    // const [selectedFile, setSelectedFile] = useState(null);

    const cancelCrop=()=>{

        setOpenCrop(false)
        setImageToCrop(undefined)
        // setSelectedFile(null)

    }


    const handlePreview = () => {
        setOpenPreview((prevState) => !prevState);
    };

    useEffect(() => {
        loadPrescriptionFiles();
    }, []);

    const loadPrescriptionFiles = () => {
        setLoading(true);
        getDoctorSignature()
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    setData(res.data);
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.errorMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                console.log("err ==== ", err);
            });
    };

    const handleUploads = (data) => {
        try {
            setLoading(true);
            updateDoctorSignature(data)
                .then((res) => {
                    setLoading(false);
                    if (res.status) {
                        toast.success(l.file_uploaded_successfully , {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        loadPrescriptionFiles();
                    }
                })
                .catch((err) => {
                    console.log("err in handleUpload === ", err);
                    setLoading(false);
                });
        } catch (e) {
            setLoading(false);
            console.log("Error", e);
        }
    };

    const handleEdit = (id) => {
        switch (id) {
            case "header":
                h_ref.current.click();
                break;
            case "sig":
                s_ref.current.click();
                break;
            case "footer":
                f_ref.current.click();
                break;
            default:
                break;
        }
    };

    const handleOpenDelete = (type) => {
        // let subject = type === "header" ? "" : type === "" ? "" : "";
        setDeleteObj({ subject: "conf_del", type });
    };

    const handleCancel = (type) => {
        setDeleteObj(null);
    };


const handleCroppedUpload=async (file)=>{

    let filename = fname;//new Date().valueOf() + file.name;
    //filename = "doctor" + target + "/" + filename;
    let target = trtgt //"signature"
    try {
        const fileUploadResBody = await uploadOnlineOrOffline(filename, file, target);
        handleUploads(fileUploadResBody);
        setImageToCrop(undefined)

        setFname(null)
    } catch (err) {
        let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
        setImageToCrop(undefined)
    }

}






    const handleDelete = async () => {
        let obj = { ...deleteObj };
        setDeleteObj(null);
        try {
            await deletedocSignature({ uploadtype: obj.type });
            loadPrescriptionFiles();
        } catch (err) {
            console.log("err in delete signature === ", err);
            let msg = err?.response?.data?.error ? err.response.data.error : "Please Try Again";
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    /**
     * @param {string} fileName - name of the file
     * @param {Object} file - file to upload
     */
    const uploadOnlineOrOffline = (fileName, file, uploadtype) => {
        setImageToCrop(undefined)
        return new Promise(async (resolve, reject) => {
            let body = {
                uploadtype,
                filetype: file.type,
                size: file.size,
                //  date: file.lastModified,
                uploadname: file.name,
            };
            if (process.env.REACT_APP_isOffline === "true") {
                //upload to server folder
                const formData = new FormData();
                formData.append("fileData", file);
                try {
                    const offlineUploadRes = await OffLineAPI.upload("api", "/uploaddoctorsign", formData);
                    body = {
                        ...body,
                        uploadurl: `${process.env.REACT_APP_api_server}/api/uploads/doctorSignature/${offlineUploadRes.path}`,
                        uploadkey: offlineUploadRes.path,
                    };
                } catch (error) {
                    return reject(error);
                }
            } else {
                //upload to s3 bucket
                try {
                    // Storage.configure({ bucket: process.env.REACT_APP_s3,region:process.env.REACT_APP_CognitoRegion });
                    // const s3UploadRes = await Storage.put(fileName, file, { contentType: file.type, customPrefix: { public: "" } });
                    // body = {
                    //     ...body,
                    //     uploadurl: `https://insta-consult.s3-ap-southeast-1.amazonaws.com/${s3UploadRes.key}`,
                    //     uploadkey: s3UploadRes.key,
                    // };

                    const formData = new FormData();
                    formData.append("file", file);

                    let params = {
                        bucket: process.env.REACT_APP_s3,
                        fileName: fileName,
                        region: process.env.REACT_APP_s3Region
                    }

                    let s3UploadRes = await scan(formData, params);


                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data
                        body = {
                            ...body,
                            uploadurl: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/${s3UploadRes.key}`,
                            uploadkey: s3UploadRes.key,
                        };
                       
                    } else {
                        console.log("s3UploadRes.........:)", s3UploadRes)
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        })
                    }



                } catch (error) {
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };

    const handleUploadFile = (e) => {
        if (e.target.files.length > 0) {
            setOpenCrop(1);
            setLoading(true);
            // const acceptedTypes = "image";
            let file = e.target.files[0];
            let target = e.target.name;

            setTrtgt(target)
            //  setImgSrc(URL.createObjectURL(file));

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (i) => {
                var _img = new Image();

                //Set the Base64 string return from FileReader as source.
                _img.src = i.target.result;
                _img.onload = async () => {
                    let width = _img.width;
                    let height = _img.height;



                    if (file) {
                        if (target === "header") {
                            if (width && height) {
                                // setLoading(false);
                                // toast.error("Please upload image with dimensions mentioned.", {
                                //     position: toast.POSITION.TOP_RIGHT,
                                // });
                                let filename = new Date().valueOf() + file.name;
                                filename = "doctor" + target + "/" + filename;

                                setFname(filename)

                                setLoading(false);
                                setImageToCrop(_img);
                                return;
                            }
                        } else if (target === "signature") {
                            if (width && height) {

                                let filename = new Date().valueOf() + file.name;
                                filename = "doctor" + target + "/" + filename;

                                setFname(filename)

                                setLoading(false);
                                setImageToCrop(_img);

                                // toast.error("Please upload image with dimensions mentioned.", {
                                //     position: toast.POSITION.TOP_RIGHT,
                                // });
                                return;
                            }
                        } else if (target === "footer") {
                            if (width && height) {
                                setLoading(false);
                                //toast.error("Please upload image with dimensions mentioned.", {
                                   // position: toast.POSITION.TOP_RIGHT,
                              //  });

                              let filename = new Date().valueOf() + file.name;
                              filename = "doctor" + target + "/" + filename;

                              setFname(filename)

                              //setLoading(false);
                              setImageToCrop(_img);

                                return;
                            }
                        }

                        let filename = new Date().valueOf() + file.name;
                        filename = "doctor" + target + "/" + filename;


                        try {
                            const fileUploadResBody = await uploadOnlineOrOffline(filename, file, target);
                            handleUploads(fileUploadResBody);
                        } catch (err) {
                            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
                            toast.error(msg, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            setLoading(false);
                        }
                        //     // code for aws s3 bucket
                        //     Storage.configure({ bucket: config.s3.BUCKET });
                        //     Storage.put(filename, file, { contentType: file.type, customPrefix: { public: "" } }).then(
                        //         (result) => {
                        //             const body = {
                        //                 uploadurl:
                        //                     "https://insta-consult.s3-ap-southeast-1.amazonaws.com" + "/" + result.key,
                        //                 uploadkey: result.key,
                        //                 uploadtype: target,
                        //                 filetype: file.type,
                        //                 // size: file.size,
                        //                 //  date: file.lastModified,
                        //                 uploadname: file.name,
                        //             };
                        //             handleUploads(body);
                        //             // code for offline file save
                        //             // const formData = new FormData();
                        //             // formData.append('fileData', file);
                        //             // OffLineAPI.upload("api", "/uploaddoctorsign", formData)
                        //             //     .then(res => {
                        //             //         // console.log("res === ", res);
                        //             //         // resolve(res);
                        //             //         const body = {
                        //             //             uploadurl: config.api_server + '/api/uploads/doctorSignature/' + res.path,
                        //             //             uploadkey: res.path,
                        //             //             filetype: file.type,
                        //             //             uploadname: file.name,
                        //             //             uploadtype: target,
                        //             //             size: file.size
                        //             //         }
                        //             //         handleUploads(body);
                        //             //     }).catch(err => {
                        //             //         toast.error(err.errorMessage, {
                        //             //             position: toast.POSITION.TOP_RIGHT
                        //             //         })
                        //             //         setLoading(false);
                        //             //     });
                        //         }
                        //     );
                        // } catch (err) {
                        //     let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
                        //     toast.error(msg, {
                        //         position: toast.POSITION.TOP_RIGHT,
                        //     });
                        //     setLoading(false);
                        //     console.log("Error", e);
                        // }
                    } else {
                        toast.error("Please upload a valid Image.", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoading(false);
                        console.log("Error", e);
                    }
                };
            };
        }
    };

    let header = null,
        footer = null,
        sign = null;

    for (let i in data) {
        let item = data[i];
        switch (item.uploadtype) {
            case "header":
                header = item;
                break;
            case "signature":
                sign = item;
                break;
            case "footer":
                footer = item;
                break;
            default:
                break;
        }
    }
    return (
        <div className="sigSettingsContainer">
            <div className="setngHeadingBox">
                <p className="subDescTxt">{l.dig_sig_desc}</p>
                <div className="flexEnd settingAction">
                    <button className="btnFilled md ripple" onClick={handlePreview}>
                        <span>{l.preview}</span>
                    </button>
                </div>
            </div>
            <div className="uploadContainer">
                {loading && <Loader />}
                <div className="uploadHBlockItem">
                    {header ? (
                        <Fragment>
                            <div className="rowBlock">
                                <div className="flexbleRow">
                                    <h3 className="uploadHdngTxt">{l.upl_header}</h3>
                                </div>
                                <div className="uploadedImgAction">
                                    <input
                                        name="header"
                                        id="header"
                                        ref={h_ref}
                                        className="uploadInput"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            handleUploadFile(e);
                                        }}
                                        hidden
                                    />
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleEdit("header")}>
                                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                                    </div>
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleOpenDelete("header")}>
                                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary"/>
                                    </div>
                                </div>
                            </div>
                            {/*** If Uploaded ***/}
                            <div className="uploadedImgBlock">
                                <div className="colBlock nopdng">
                                    <div className="uploadedImgLeft">
                                        <div className="uploadedImgThumbnail uploadedHdrThumbnail">
                                            <div className="uploadedImgContainer">
                                                <img src={header.uploadurl} alt="banner" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="uploadedImgInfoBlock">
                                    <span className="listTxtL linkTxt">Image File Name.png</span>
                                    <span className="listTxtM">234.43 MB</span>
                                </div> */}
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="uploadHeadBox">
                            <input
                                name="header"
                                id="header"
                                ref={h_ref}
                                className="uploadInput"
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    handleUploadFile(e);
                                }}
                            />
                            <div className="uploadIconBox">
                                <img src="/images/icons/upload.png" className="invertGray" alt="icon" />
                            </div>
                            <label htmlFor="header">{l.upl_header_txt}</label>
                            <div className="uploadBlockInnerSize">
                                <span className="uploadBoxSize">595</span>
                                &nbsp;<small>X</small>&nbsp;
                                <span className="uploadBoxSize">100 px</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="uploadHBlockItem">
                    {sign ? (
                        <Fragment>
                            <div className="rowBlock">
                                <div className="flexbleRow">
                                    <h3 className="uploadHdngTxt">{l.upl_dig_sig}</h3>
                                </div>
                                <div className="uploadedImgAction">
                                    <input
                                        ref={s_ref}
                                        name="signature"
                                        className="uploadInput"
                                        type="file"
                                        id="sig"
                                        accept="image/*"
                                        onChange={(e) => handleUploadFile(e)}
                                        hidden
                                    />
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleEdit("sig")}>
                                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary"/>
                                    </div>
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleOpenDelete("signature")}>
                                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                                    </div>
                                </div>
                            </div>
                            <div className="uploadedImgBlock">
                                <div className="colBlock nopdng">
                                    <div className="uploadedImgLeft">
                                        <div className="uploadedImgThumbnail uploadSigThumbnail">
                                            <div className="uploadedImgContainer">
                                                <img src={sign.uploadurl} alt="signature" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="uploadedImgInfoBlock">
                                    <span className="listTxtL linkTxt">Image File Name.png</span>
                                    <span className="listTxtM">234.43 MB</span>
                                </div> */}
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="uploadHeadBox">
                            <input name="signature" ref={s_ref} className="uploadInput" type="file" id="sig"  accept="image/*" onChange={(e) => handleUploadFile(e)} />
                            <div className="uploadIconBox">
                                <img src="/images/icons/upload.png" className="invertGray" alt="icon" />
                            </div>
                            <label htmlFor="sig">{l.upl_dig_sig_txt}</label>
                            <div className="uploadBlockInnerSize">
                                <span className="uploadBoxSize">260 </span>
                                <small>&nbsp;X&nbsp;</small>
                                <span className="uploadBoxSize">80 px</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="uploadHBlockItem">
                    {footer ? (
                        <Fragment>
                            <div className="rowBlock">
                                <div className="flexbleRow">
                                    <h3 className="uploadHdngTxt">{l.upl_footer}</h3>
                                </div>
                                <div className="uploadedImgAction">
                                    <input
                                        className="uploadInput"
                                        ref={f_ref}
                                        type="file"
                                        name="footer"
                                        id="footer"
                                        accept="image/*"
                                        onChange={(e) => handleUploadFile(e)}
                                        hidden
                                    />
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleEdit("footer")}>
                                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                                    </div>
                                    <div className="iconBtnBlock primary Sm ripple" onClick={(e) => handleOpenDelete("footer")}>
                                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                                    </div>
                                </div>
                            </div>
                            <div className="uploadedImgBlock">
                                <div className="colBlock nopdng">
                                    <div className="uploadedImgLeft">
                                        <div className="uploadedImgThumbnail uploadFooterThumbnail">
                                            <div className="uploadedImgContainer">
                                                <img src={footer.uploadurl} alt="footer" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="uploadedImgInfoBlock">
                                    <span className="listTxtL linkTxt">Image File Name.png</span>
                                    <span className="listTxtM">234.43 MB</span>
                                </div> */}
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="uploadHeadBox">
                            <input className="uploadInput" type="file" ref={f_ref} name="footer" id="footer"  accept="image/*" onChange={(e) => handleUploadFile(e)} />
                            <div className="uploadIconBox">
                                <img src="/images/icons/upload.png" className="invertGray" alt="icon" />
                            </div>
                            <label htmlFor="footer">{l.upl_footer_txt}</label>
                            <div className="uploadBlockInnerSize">
                                <span className="uploadBoxSize">595 </span>
                                <small>&nbsp;X&nbsp;</small>
                                <span className="uploadBoxSize">56 px</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div>

            {(imageToCrop && openCrop) &&
            <div className={imageToCrop ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="cropperPaper">


                <Demo cancelCrop={cancelCrop} target={trtgt} cropRatio={16/9} imageToCrop={imageToCrop.src}

                onImageCropped={(croppedImage) => handleCroppedUpload(croppedImage)}
                >

                </Demo>
            </div>
            </div>
            }
            {/* {imageToCrop && (
                <div className={imageToCrop ? "btmDtlSlider visible" : "btmDtlSlider"}>
                    <div className="cropperPaper">
                        <ImageCropper
                            imageToCrop={imageToCrop.src}
                            onImageCropped={(croppedImage) => handleCroppedUpload(croppedImage)}
                            closeImageCrop={closeImageCrop}
                        />
                    </div>
                </div>
            )} */}
            </div>
            {deleteObj && (
                <ConfirmDeleteModal
                    open={deleteObj !== null}
                    title={"delete"}
                    subject={deleteObj.subject}
                    handleCancel={handleCancel}
                    handleDelete={handleDelete}
                />
            )}
            {openPreview && <PreviewTemplate open={openPreview} data={data} handleClose={handlePreview} />}
        </div>
    );
};

export default DigitalSignature;
